import { TranslatePipe } from '../../filters/translate.pipe';
import { Component, OnInit } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import { Input, Output, EventEmitter } from '@angular/core';

@Component({
	standalone: true,
	selector: 'button-conversations',
	templateUrl: './button-conversations.component.html',
	imports: [ CommonModule, TranslatePipe, FormsModule ]
})
export class ButtonConversationsComponent implements OnInit {
	
	@Input() chats: any;
	@Output() chatsChange: EventEmitter<any> = new EventEmitter<any>(); // TODO ANGULAR_2: fix calling event emitter
	@Input() limit: any;
	
	vm: any = undefined;
	
	constructor() {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.openChat = this.openChat;
		this.vm.removeChat = this.removeChat;
	}

	openChat(chat) {
		this.vm.chats.splice(this.vm.chats.indexOf(chat), 1);
		this.vm.chats.unshift(chat);
	}

	removeChat(chat) {
		this.vm.chats.splice(this.vm.chats.indexOf(chat), 1);
	}
	
}